"use strict";

import {findAll} from '@elements/dom-utils'

export function init() {
    let svgConverter = findAll('.js-svg-converter');

    svgConverter.forEach((svgItem) => {
        let elem = svgItem;
        let svgFileString = elem.innerHTML;

        let svgData = elem.dataset.json;
        let attributes = [];

        if (svgData) {
            if (!window['_svgTransform']) {
                console.error('_svgTransform is not set');
            } else if (!window._svgTransform[svgData]) {
                console.error(svgData + ' is not set in _svgTransform', _svgTransform);
            } else {
                attributes = _svgTransform[svgData];
            }


            for (let key in attributes) {
                let replaceStr = "#"+key+"#";
                let lines = attributes[key].split('<br>');
                let newContent = "";
                for (let i = 0; i < lines.length; i++) {
                    let dy = i===0 ? "0" : "1.2em" ;
                    newContent += "<tspan x='0' dx='0' dy="+ dy +">"+lines[i]+"</tspan>";
                }

                svgFileString = svgFileString.replace(new RegExp(replaceStr, "g"), newContent);
            }

            elem.innerHTML = svgFileString;
        }
    });
}
